import { FormNumericInput } from 'components/shared';
import React from "react"

export const EditableCellInputNumber = React.memo(({
    value,
    name,
    onChange,
    disabled = false
}) => {
  return (
    <FormNumericInput
      className='text-center'
      name={name}
      size='xs'
      value={value}
      disabled={disabled}
      onValueChange={(values) => onChange?.(values.floatValue ?? 0)}
      thousandSeparator="."
      decimalSeparator=","
    />
  )
});

export default EditableCellInputNumber;